import { EventsActions } from '../../../../actions';

const {REACT_APP_SAVE_ON_CHANGE_TIMEOUT} = process.env;

export const handleChange = function (event) {
    var name = event.target.name;
    var value = event.target.value;

    var obj = {};
    name = name.split(".");

    switch(name.length) {
        case 2: 
            obj[name[0]] = {...this.state.eventData[name[0]]};
            obj[name[0]][name[1]] = value;
            break;
        default: 
            obj[name[0]] = value;
            break;
    }

    const updateState = {
        eventData: {...this.state.eventData, ...obj},
    };

    if(this.state.fields) {
        updateState.fields = {...this.state.fields, ...obj}
    }

    this.setState({...updateState}, this.updateTimeout);
}

/**
 * intended for update once per input change 
 * prevent multiple update while user change the input
 */
export const updateTimeout = function() {
    clearTimeout(this.updateTimeoutID);

    this.updateTimeoutID = setTimeout(update.bind(this), REACT_APP_SAVE_ON_CHANGE_TIMEOUT);
}

export const update = function() {
    const valid = this.validation ? this.validation() : true;

    if(!this.state.eventFinised && valid) {
        const { dispatch, events } = this.props;
        const data = {...this.state.eventData};
        
        dispatch(EventsActions.updateEvent(events.currentEventID, data));
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/settings/event/utils.js